import React, { useState, useEffect } from "react";
import { Redirect, Route, Link, useHistory } from "react-router-dom";
import auth from "../services/auth";
import Spinner from "../elements/Spinner";
import AppContext from "../contexts/AppContext";
import api from "../services/api";
import emailValidate from "../services/emailValidate";
import "styles/_security_popup.scss";
import { __ } from "services/Translator";

import validator from "validator";
import swal from "sweetalert";

import { Modal, Button, Alert } from "react-bootstrap";

const SecurityPopup = (props) => {
  const history = useHistory();
  const spinner = props.spinner;
  const setSpinner = props.setSpinner;
  const isAuthenticated = props.isAuthenticated;

  const [security, setSecurity] = useState(false);
  const [securityPopupModal, setSecurityPopupModal] = useState(false);
  const [securityPopupData, setSecurityPopupData] = useState({
    login: "",
    password: "",
  });

  const [securityPopupDataErrors, setSecurityPopupDataErrors] = useState({
    login: "",
    password: "",
  });

  const updateSecurityPopupInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    var type = target.type;
    // updateRegistrationForm(field, value);
    setSecurityPopupData({ ...securityPopupData, [field]: value });
  };

  const securityPopupLogin = async (ev) => {
    ev.preventDefault();
    var valid = validateSecurityPopupForm();
    if (valid) {
      setSpinner(true);
      var response = await api.post("/pre-login", securityPopupData);
      setSpinner(false);
      if (response.status == 200) {
        //Here, no actual user token is provided. So, user is still not logged in
        //However, this temporary token will get past the security popup
        await auth.login(response.data.user);
        setSecurity(false);
      }
    }
  };

  const validateSecurityPopupForm = () => {
    var valid = true;
    // return valid;
    var errorsTmp = {};
    if (
      securityPopupData.login.length < 2 ||
      securityPopupData.login.length > 250
    ) {
      errorsTmp = { ...errorsTmp, login: __("Please enter the user name") };
      valid = false;
    }

    if (
      securityPopupData.password.length < 2 ||
      securityPopupData.password.length > 250
    ) {
      errorsTmp = { ...errorsTmp, password: __("Please enter the password") };
      valid = false;
    }

    setSecurityPopupDataErrors(errorsTmp);

    return valid;
  };

  const ping = async () => {
    var response = await api.get("/ping");
    if (response.status === 200) {
      setSecurity(false);
    } else if (response.status === 403) {
      if (response.data && response.data.showSecurityPopup) {
        var userId = auth.getUserId();
        if (!userId) {
          setSecurity(true);
        }
      }
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      ping();
    }
    const interval = setInterval(() => {
      if (!isAuthenticated) {
        ping();
      }
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  const openModal = () => {
    setSecurityPopupModal(true);
  };
  const closeModal = () => {
    setSecurityPopupModal(false);
  };

  return (
    <>
      {security && (
        <>
          <div className="security_overlay">
            <div className="security_popup_logo">
              {/* <img
                src={
                  require("assets/images/logos/blizz-casino-logo-gradient.svg")
                    .default
                }
              /> */}
              <img src={require("assets/images/blizzlau.png").default} />
            </div>
            <Link
              to="#"
              onClick={openModal}
              className="security_popup_trigger common_btn only_border"
            >
              {__("Login")}
            </Link>
          </div>
          <Modal show={securityPopupModal}>
            <Modal.Body className="login_modal security_popup">
              <div onClick={closeModal} className="modal_close">
                <i className="fal fa-times"></i>
              </div>
              <div className="modal_headline">
                {__("Maintenance. Back online in 30 minutes")}…
              </div>
              <form onSubmit={securityPopupLogin}>
                <div className="form_area">
                  <div className="input_item">
                    <div className="name">
                      {__("User Name")} <span className="requried_icon">*</span>
                    </div>
                    <input
                      type="text"
                      name="login"
                      onChange={updateSecurityPopupInput}
                      value={securityPopupData.login}
                      className={
                        "form-control name_value " +
                        (securityPopupDataErrors.login ? "error" : "")
                      }
                    />
                    <div className="errorMsg">
                      {securityPopupDataErrors.login}
                    </div>
                  </div>

                  <div className="input_item">
                    <div className="name">
                      {__("Password")}
                      <span className="requried_icon">*</span>
                    </div>
                    <input
                      type="password"
                      name="password"
                      onChange={updateSecurityPopupInput}
                      value={securityPopupData.password}
                      className={
                        "form-control name_value " +
                        (securityPopupDataErrors.password ? "error" : "")
                      }
                    />
                    <div className="errorMsg">
                      {securityPopupDataErrors.password}
                    </div>
                  </div>
                  <div className="login_button">
                    <Button type="submit" className="login_btn">
                      {__("Login")}
                    </Button>
                  </div>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default SecurityPopup;
